import { EMPTY_SELECT_VALUE } from 'src/components/UI/dropdown/Dropdown';
import { BaseApiResponseType } from 'src/models/BaseApi';
import {
  CampaignQuickActionPanelMenuType,
  CampaignSaveArchiveUnarchiveReturnType,
  CampaignSaveArchiveUnarchiveType,
} from 'src/models/Campaigns';
import { MyCampaignsListItemType, MyCampaignUnArchiveType } from 'src/models/Campaigns/MyCampaigns';
import {
  DonationPageContributionNotificationEmailsRequestType,
  DonationPageContributionNotificationEmailsResponseType,
} from 'src/models/DonationPage/ContribuitionNotificationEmails';
import {
  DonationPageFirstFormValues,
  DonationPageSaveFormType,
  DonationPageSecondFormValues,
  DonationPageThirdFormValues,
} from 'src/models/DonationPage/Form';
import {
  DonationPageFriendlyUrlRequestType,
  DonationPageFriendlyUrlResponseType,
} from 'src/models/DonationPage/FriendlyUrl';
import {
  DonationPageLoadSubmitDialogRequestType,
  DonationPageLoadSubmitDialogResponseType,
} from 'src/models/DonationPage/LoadSubmitDialog';
import {
  DonationPageValidatePromocodeRequestType,
  DonationPageValidatePromocodeResponseType,
} from 'src/models/DonationPage/Promocode';
import {
  DonationPageCheckoutSectionRequestType,
  DonationPageMainSectionRequestType,
  DonationPageOptionSectionRequestType,
  DonationPageResponseType,
  DonationPageTabsEnum,
} from 'src/models/DonationPage/Section';
import {
  DonationPageSubmitCampaignRequestType,
  DonationPageSubmitCampaignResponseType,
} from 'src/models/DonationPage/SubmitCampaign';
import {
  DonationPageTextToGiveValidateRequestType,
  DonationPageTextToGiveValidateResponseType,
} from 'src/models/DonationPage/TextToGive';
import { Enums } from 'src/models/enums';
import { UpsellLoadUpdatePricingDialogResponseType } from 'src/models/plusSubscription';
import {
  deDonationPageFirstFormSectionSelector,
  deDonationPageSecondFormSectionSelector,
  deDonationPageThirdFormSectionSelector,
  donationPageCurrentTimelineSectionSelector,
} from 'src/pages/DonationSetup/containers/selectors';
import { store } from 'src/store/store';
import { normalizeFileUrl } from 'src/utils/formHelper';
import { ApiFunctionType, httpPost, httpPostCancellable } from 'src/utils/http';
import { SortDirectionEnum } from 'src/utils/types';

const EMPTY_STRING = 'empty';

export const apiSaveDonationForm = ({
  id,
  currentFormName,
  data,
  nextFormName,
}: DonationPageSaveFormType): Promise<DonationPageResponseType> => {
  /** get a progress value from the store to save with a form */
  const { progress } = donationPageCurrentTimelineSectionSelector(store.getState());

  switch (currentFormName) {
    case DonationPageTabsEnum.FIRST: {
      const formValues = data as DonationPageFirstFormValues; // cast as a correct form

      /** get more data from the store */
      const { imageId, imageUri } = deDonationPageFirstFormSectionSelector(store.getState());

      // const PricingTypeCode =
      //   formValues.defaultPricingViewModel.pricingTypeCode ?? defaultPricingViewModel.pricingTypeCode;
      //
      // const DefaultPricingServiceFeeChargingTypeID =
      //   formValues.defaultPricingViewModel.DefaultPricingServiceFeeChargingTypeID ??
      //   defaultPricingViewModel.DefaultPricingServiceFeeChargingTypeID;

      const model: DonationPageMainSectionRequestType = {
        nextSectionName: nextFormName,
        viewModel: {
          Progress: progress,
          IsDirty: true,
          PermanentUrl: id,
          CampaignName: formValues.CampaignName,
          ShortDescription: formValues.shortDescription,
          ShowCampaignHeadline: formValues.showCampaignHeadline,
          // IsStartCampaignAutomatically: formValues.startCampaignAutomatically,
          // DesiredStartDate: formValues.DesiredStartDate || '',
          // DesiredStartTime: formValues.DesiredStartTime || '',
          Medias: {
            Items: [
              {
                ID: imageUri === formValues.ImageUri ? imageId : null,
                MediaType: Enums.campaigns.MediaTypeCode.Image,
                ImageUri: formValues.ImageUri ? normalizeFileUrl(formValues.ImageUri) : null,
              },
            ],
          },
          // ContributionButtonTerminology: {
          //   SelectedTerminology: {
          //     ID: formValues.callToAction.value,
          //     Text: formValues.callToAction.text || EMPTY_STRING,
          //     IsDefault: !!formValues.callToAction.value,
          //   },
          // },
          UseContributionAmountPresets: formValues.UseContributionAmountPresets,
          ContributionAmountPresets: formValues.ContributionAmountPresets ? formValues.ContributionAmountPresets : [],
          IsContributionPresetsSortDesc: formValues.contributionPresetsSort === SortDirectionEnum.DESC,
          // PaymentMethods: Object.entries(formValues.paymentMethods).map(([valueStr, selected]) => ({
          //   Value: parseInt(valueStr, 10),
          //   IsSelected: selected,
          // })),
          // CurrencyTypeID: formValues.currencySelected,
          // Check:
          //   formValues.check && formValues.paymentMethods[`${Enums.campaigns.PaymentTypeCode.Check}_`]
          //     ? {
          //         CountryID: formValues.check.countryID,
          //         CheckName: formValues.check.checkName as string,
          //         CheckPayableTo: formValues.check.checkPayableTo as string,
          //         CheckZipCode: formValues.check.checkZipCode as string,
          //         CheckCity: formValues.check.checkCity as string,
          //         RegionID: formValues.check.regionID as number,
          //         CheckAttentionTo: formValues.check.checkAttentionTo,
          //         CheckAddressLine1: formValues.check.checkAddressLine1 as string,
          //         CheckAddressLine2: formValues.check.checkAddressLine2,
          //         CheckAddressLine3: formValues.check.checkAddressLine3,
          //       }
          //     : undefined,
          // IsAddressRequired: formValues.isAddressRequired,
          // IsPhoneNumberRequired: formValues.isPhoneNumberRequired,
          // EmailSubject: formValues.emailSubject,
          // EmailTemplate: formValues.emailTemplate,
          // TextToGiveViewModel: {
          //   IsTextToGiveEnabled: formValues.textToGive.enabled,
          //   TextToGiveKeyword: formValues.textToGive.keyword,
          // },
          FriendlyUrl: formValues.friendlyUrl,
          // DefaultPricingViewModel: {
          //   ProcessingFeesChargedToSupporter:
          //     PricingTypeCode === Enums.campaigns.PricingTypeCode.Percentage &&
          //     defaultPricingViewModel.serviceFeeRate === 0
          //       ? DefaultPricingServiceFeeChargingTypeID !== Enums.campaigns.FeeChargingTypeCode.ChargeOrganizer
          //       : null,
          //   DefaultPricingServiceFeeChargingTypeID,
          //   PromoCodeFeeChargingTypeCode:
          //     formValues.defaultPricingViewModel.promoCodeFeeChargingTypeCode ??
          //     defaultPricingViewModel.promoCodeFeeChargingTypeCode,
          //   ConvenienceFeeAmount:
          // eslint-disable-next-line max-len
          //     formValues.defaultPricingViewModel.convenienceFeeAmount ?? defaultPricingViewModel.convenienceFeeAmount,
          //   IsConvenienceFeeEnabled:
          //     formValues.defaultPricingViewModel.isConvenienceFeeEnabled ??
          //     defaultPricingViewModel.isConvenienceFeeEnabled,
          //   PricingTypeCode,
          // },
          CauseTerminology: {
            SelectedTerminology: {
              IsCampaignSpecific: formValues.cause.value === EMPTY_SELECT_VALUE,
              TerminologyType: 10,
              ID: formValues.cause.value,
              Article: formValues.cause.article === 'a' ? 'A' : 'An',
              Singular: formValues.cause.singular || EMPTY_STRING,
              Plural: formValues.cause.plural || EMPTY_STRING,
            },
          },
          UseCauses: formValues.UseCauses,
          DonationPageDisplayingConfigurationModel: {
            IsBannerEnabled: formValues.DonationPageDisplayingConfigurationModel.IsBannerEnabled || false,
            IsFundImageEnabled: formValues.DonationPageDisplayingConfigurationModel.IsFundImageEnabled || false,
            IsPresetDonationDescriptionEnabled:
              formValues.DonationPageDisplayingConfigurationModel.IsPresetDonationDescriptionEnabled || false,
            IsPresetDonationImageEnabled:
              formValues.DonationPageDisplayingConfigurationModel.IsPresetDonationImageEnabled || false,
            IsPresetDonationTitleEnabled:
              formValues.DonationPageDisplayingConfigurationModel.IsPresetDonationTitleEnabled || false,
            // ShowDefaultPricingCard: defaultPricingViewModel.showDefaultPricingCard
          },
        },
      };

      return httpPost('/CampaignsSetup/SaveDonationPagesSection', model);
    }
    case DonationPageTabsEnum.SECOND: {
      const formValues = data as DonationPageSecondFormValues; // cast as a correct form

      /** get more data from the store */
      const { defaultPricingViewModel, paymentMethods, PlusSubscriptionPricingViewModel } =
        deDonationPageSecondFormSectionSelector(store.getState());

      const PricingTypeCode =
        formValues.defaultPricingViewModel.pricingTypeCode ?? defaultPricingViewModel.pricingTypeCode;

      const DefaultPricingServiceFeeChargingTypeID =
        formValues.defaultPricingViewModel.DefaultPricingServiceFeeChargingTypeID ??
        defaultPricingViewModel.DefaultPricingServiceFeeChargingTypeID;

      const DefaultPricingProcessingFeeChargingTypeID =
        formValues.defaultPricingViewModel.DefaultPricingProcessingFeeChargingTypeID ??
        defaultPricingViewModel.DefaultPricingProcessingFeeChargingTypeID;

      const hiddenPaymentMethods = paymentMethods
        .filter(({ hidden }) => hidden)
        .map((item) => ({
          Value: item.value,
          IsSelected: item.selected,
        }));

      const displayedPaymentMethods = Object.entries(formValues.paymentMethods).map(([valueStr, selected]) => ({
        Value: parseInt(valueStr, 10),
        IsSelected: selected,
      }));

      const model: DonationPageCheckoutSectionRequestType = {
        nextSectionName: nextFormName,
        viewModel: {
          Progress: progress,
          IsDirty: true,
          PermanentUrl: id,
          Check:
            formValues.check && formValues.paymentMethods[`${Enums.campaigns.PaymentTypeCode.Check}_`]
              ? {
                  CountryID: formValues.check.countryID,
                  CheckName: formValues.check.checkName as string,
                  CheckPayableTo: formValues.check.checkPayableTo as string,
                  CheckZipCode: formValues.check.checkZipCode as string,
                  CheckCity: formValues.check.checkCity as string,
                  RegionID: formValues.check.regionID as number,
                  CheckAttentionTo: formValues.check.checkAttentionTo,
                  CheckAddressLine1: formValues.check.checkAddressLine1 as string,
                  CheckAddressLine2: formValues.check.checkAddressLine2,
                  CheckAddressLine3: formValues.check.checkAddressLine3,
                }
              : undefined,
          PaymentMethods: [...hiddenPaymentMethods, ...displayedPaymentMethods],
          CurrencyTypeID: formValues.currencySelected,
          EmailSubject: formValues.emailSubject,
          EmailTemplate: formValues.emailTemplate,
          AllowDonationDedication: formValues.allowDonationDedication,
          UseCustomMinMaxContributionAmount: formValues.useCustomMinMaxContributionAmount,
          MinimumContributionAmount: formValues.minimumContributionAmount,
          MaximumContributionAmount: formValues.maximumContributionAmount,
          EnableMarketingEmailsOption: formValues.enableMarketingEmailsOption,
          EnableMarketingEmailsOptionLabel: formValues.enableMarketingEmailsOptionLabel,
          TextToGiveViewModel: {
            IsTextToGiveEnabled: formValues.textToGive.enabled,
            TextToGiveKeyword: formValues.textToGive.keyword,
            IsInternationalTextToGiveEnabled: formValues.textToGive.internationalEnabled,
          },
          IsAddressRequired: formValues.isAddressRequired,
          IsPhoneNumberRequired: formValues.isPhoneNumberRequired,
          CustomFields: {
            BasicFields: [],
            CustomFields: formValues.CustomFields.CustomFields.map(
              ({ ID, IsRequired, Name, CustomFieldTypeID, HasOtherOption, Options }, index) => ({
                ID: ID < 0 ? null : ID,
                Name,
                Collect: true,
                IsRequired,
                Sequence: index + 1,
                CustomFieldTypeID,
                Readonly: false,
                HasOtherOption,
                Options: Options.map(({ Name, ID }, index) => ({
                  ID: ID < 0 ? null : ID,
                  Name,
                  Sequence: index + 1,
                })),
              })
            ),
          },
          DefaultPricingViewModel: {
            ConvenienceFeeAmountType: formValues.defaultPricingViewModel.ConvenienceFeeAmountType,
            ProcessingFeesChargedToSupporter:
              formValues.defaultPricingViewModel.processingFeesChargedToSupporter ??
              defaultPricingViewModel.processingFeesChargedToSupporter,
            DefaultPricingServiceFeeChargingTypeID,
            DefaultPricingProcessingFeeChargingTypeID,
            PromoCodeFeeChargingTypeCode:
              formValues.defaultPricingViewModel.promoCodeFeeChargingTypeCode ??
              defaultPricingViewModel.promoCodeFeeChargingTypeCode,
            ConvenienceFeeAmount:
              formValues.defaultPricingViewModel.ConvenienceFeeAmount ?? defaultPricingViewModel.ConvenienceFeeAmount,
            IsConvenienceFeeEnabled:
              formValues.defaultPricingViewModel.isConvenienceFeeEnabled ??
              defaultPricingViewModel.isConvenienceFeeEnabled,
            PricingTypeCode,
            ShowDefaultPricingCard: defaultPricingViewModel.showDefaultPricingCard,
          },
          PlusSubscriptionPricingViewModel: {
            DefaultPricingServiceFeeChargingTypeID:
              formValues.PlusSubscriptionPricingViewModel.DefaultPricingServiceFeeChargingTypeID ??
              PlusSubscriptionPricingViewModel.DefaultPricingServiceFeeChargingTypeID,
            DefaultPricingProcessingFeeChargingTypeID:
              formValues.PlusSubscriptionPricingViewModel.DefaultPricingProcessingFeeChargingTypeID ??
              PlusSubscriptionPricingViewModel.DefaultPricingProcessingFeeChargingTypeID,
            IsConvenienceFeeEnabled:
              formValues.PlusSubscriptionPricingViewModel.isConvenienceFeeEnabled ??
              PlusSubscriptionPricingViewModel.isConvenienceFeeEnabled,
            ConvenienceFeeAmountType: formValues.PlusSubscriptionPricingViewModel.ConvenienceFeeAmountType,
            ConvenienceFeeAmount:
              formValues.PlusSubscriptionPricingViewModel.ConvenienceFeeAmount ??
              PlusSubscriptionPricingViewModel.ConvenienceFeeAmount,
            ProcessingFeesChargedToSupporter:
              formValues.PlusSubscriptionPricingViewModel.processingFeesChargedToSupporter ??
              PlusSubscriptionPricingViewModel.processingFeesChargedToSupporter,
            ShowPlusSubscriptionPricingCard: PlusSubscriptionPricingViewModel.showPlusSubscriptionPricingCard,
          },
        },
      };

      return httpPost('/CampaignsSetup/SaveDonationPageCheckoutSection', model);
    }
    case DonationPageTabsEnum.THIRD: {
      /** get more data from the store */
      const {
        UkGiftAidShown,
        canHaveAdditionalAmount,
        areFixedContributionsAllowedVisible,
        isDonationWithoutItemsHeadlineAndButtonVisible,
        showAreCompleteAnonymousContributions,
        showSpecialInstructions,
      } = deDonationPageThirdFormSectionSelector(store.getState());

      const formValues = data as DonationPageThirdFormValues; // cast as a correct form

      const model: DonationPageOptionSectionRequestType = {
        nextSectionName: nextFormName,
        viewModel: {
          TimezoneID: formValues.timezone,
          CampaignTabTitle: {
            Header: 'Donation Page tab',
            ValidatationAttribute: 'CampaignTabTitle',
            FundraisingActivityType: null,
            Title: 'Donation Page',
          },
          TerminologiesViewModel: {
            ShowContributionTerminology: true, // if not set to true it won't be saved
            SupporterTerminologyModel: {
              SelectedTerminology: {
                ID: formValues.terminology.value,
                Article: formValues.terminology.article === 'a' ? 'A' : 'An',
                Singular: formValues.terminology.singular || EMPTY_STRING,
                Plural: formValues.terminology.plural || EMPTY_STRING,
                IsCampaignSpecific: formValues.terminology.value === EMPTY_SELECT_VALUE,
                TerminologyType: 13, // hardcode
              },
            },
            ContributionTerminologyModel: {
              SelectedTerminology: {
                ID: formValues.contribution.value,
                Article: formValues.contribution.article === 'a' ? 'A' : 'An',
                Singular: formValues.contribution.singular || EMPTY_STRING,
                Plural: formValues.contribution.plural || EMPTY_STRING,
                IsCampaignSpecific: formValues.contribution.value === EMPTY_SELECT_VALUE,
                Verb: formValues.contribution.verb || EMPTY_STRING,
                TerminologyType: 15, // hardcode
              },
            },
          },
          PermanentUrl: id,
          Progress: progress,
          HaveFundCode: formValues.hasFundCode,
          FundCode: formValues.hasFundCode ? formValues.FundCode : null,
          IsDirty: true,
          PricingViewModel: {
            ShowOrganizerPromoCode: formValues.showOrganizerPromoCode,
            HaveOrganizerPromoCode: formValues.OrganizerPromoCode !== null,
            OrganizerPromoCode: formValues.OrganizerPromoCode,
            PermanentUrl: id,
          },
          IsUkGiftAidEnabled: UkGiftAidShown ? formValues.UkGiftAidEnabled : false,
          GiftAidStatement: UkGiftAidShown ? formValues.giftAidText : null,
          GiftAidAgreement: UkGiftAidShown ? formValues.giftAidAgreementText : null,
          ContributionBankStatement: formValues.ContributionBankStatement,
          ShowAdditionalAmount: canHaveAdditionalAmount ? formValues.showAdditionalAmount : false,
          AreFixedContributionsAllowed: areFixedContributionsAllowedVisible
            ? formValues.areFixedContributionsAllowed
            : false,
          DonationWithoutItemsHeadLineText:
            areFixedContributionsAllowedVisible && isDonationWithoutItemsHeadlineAndButtonVisible
              ? formValues.donationWithoutItemsHeadLineText
              : null,
          DonateWithoutItemsButtonText:
            areFixedContributionsAllowedVisible && isDonationWithoutItemsHeadlineAndButtonVisible
              ? formValues.donateWithoutItemsButtonText
              : null,
          AreCompleteAnonymousContributionsDisabled: showAreCompleteAnonymousContributions
            ? !formValues.areCompleteAnonymousContributionsEnabled
            : false,
          AllowDonationDedication: formValues.allowDonationDedication,
          IsSpecialInstructionsVisible: showSpecialInstructions ? formValues.isSpecialInstructionsVisible : false,
          UseCustomMinMaxContributionAmount: formValues.useCustomMinMaxContributionAmount,
          MinimumContributionAmount: formValues.useCustomMinMaxContributionAmount
            ? formValues.minimumContributionAmount
            : null,
          MaximumContributionAmount: formValues.useCustomMinMaxContributionAmount
            ? formValues.maximumContributionAmount
            : null,
          EnableMarketingEmailsOption: formValues.enableMarketingEmailsOption,
          EnableMarketingEmailsOptionLabel: formValues.enableMarketingEmailsOption
            ? formValues.EnableMarketingEmailsOptionLabel
            : null,
          Notice: formValues.notice,
          IsSupporterNoticeAcknowledgmentRequired: formValues.isSupporterNoticeAcknowledgmentRequired,
          ContributionNotificationRecipients: formValues.ContributionNotificationRecipients.map((Email) => ({ Email })),
          ContactOrganizerEmailRecipients: formValues.ContactOrganizerEmailRecipients.map((Email) => ({ Email })),
          AreNotificationsAboutNewDonorsAndDonationsEnabled:
            formValues.AreNotificationsAboutNewDonorsAndDonationsEnabled,
          AllowRecurringDonations: formValues.AllowRecurringDonations,
          IsRecurringDonationUpsellEnabled: formValues.IsRecurringDonationUpsellEnabled,
          AllowDonorsChooseRecurringDonationFrequency: formValues.AllowDonorsChooseRecurringDonationFrequency,
          DefaultRecurrencePeriodID: formValues.DefaultRecurrencePeriodID,
          UpsellPercentage: formValues.UpsellPercentage,
          UpsellTitle: formValues.UpsellTitle,
          UpsellDescription: formValues.UpsellDescription,
          EnableAnonymousDonation: formValues.EnableAnonymousDonation,
          EnableHideEmail: formValues.EnableHideEmail,
          IntegrationsOptionsSubsectionViewModel: {
            BloomerangFields: {
              CampaignFieldValueID: formValues.bloomerangFields.campaignFieldValueID,
              FundFieldValueID: formValues.bloomerangFields.fundFieldValueID,
              AppealFieldValueID: formValues.bloomerangFields.appealFieldValueID,
            },
            LittleGreenLightFields: {
              CampaignFieldValueID: formValues.littleGreenLightFields.campaignFieldValueID,
              FundFieldValueID: formValues.littleGreenLightFields.fundFieldValueID,
              AppealFieldValueID: formValues.littleGreenLightFields.appealFieldValueID,
              EventFieldValueID: formValues.littleGreenLightFields.eventFieldValueID,
            },
            OrganizationId: formValues.organizationId,
          },
        },
      };

      return httpPost('/CampaignsSetup/SaveDonationPageOptionsSection', model);
    }
    default: {
      // eslint-disable-next-line no-promise-executor-return
      return new Promise((_, reject) => reject(new Error("Unrecognized form's type to save")));
    }
  }
};

export const apiValidateTextToGive = ({
  text,
  permanentUrl,
}: DonationPageTextToGiveValidateRequestType): Promise<DonationPageTextToGiveValidateResponseType> =>
  httpPost('/CampaignsSetup/ValidateTextToGive', { TextToGiveKeyword: text, PermanentUrl: permanentUrl });

export const apiValidatePromocode = (
  data: DonationPageValidatePromocodeRequestType
): Promise<DonationPageValidatePromocodeResponseType> => httpPost('/Campaigns/ValidateOrganizerPromoCode', data);

export const apiValidateFriendlyUrl = ({
  url,
  permanentUrl,
}: DonationPageFriendlyUrlRequestType): Promise<DonationPageFriendlyUrlResponseType> =>
  httpPost('/CampaignsSetup/ValidateCampaignFriendlyUrl', { FriendlyUrl: url, PermanentUrl: permanentUrl });

export const apiValidateCampaign = (permanentUrl: string): Promise<BaseApiResponseType> =>
  httpPost('/CampaignsSetup/ValidateCampaign', { permanentUrl });

export const apiValidateCampaignPlusSubscription = (permanentUrl: string): Promise<BaseApiResponseType> =>
  httpPost('/campaignssetup/validateplussubscriptionifneeded', { permanentUrl });

export const apiLoadSubmitDialog = (
  permanentUrl: DonationPageLoadSubmitDialogRequestType
): Promise<DonationPageLoadSubmitDialogResponseType> => httpPost('/CampaignsSetup/LoadSubmitDialog', { permanentUrl });

export const apiSubmitCampaign = ({
  PermanentUrl,
  CurrencyTypeID,
}: DonationPageSubmitCampaignRequestType): Promise<DonationPageSubmitCampaignResponseType> =>
  httpPost('/Campaigns/SubmitCampaign', { permanentUrl: PermanentUrl, CurrencyTypeID });

/** archive/unarchive */
export const apiCampaignArchiveUnarchiveModel: ApiFunctionType<
  CampaignSaveArchiveUnarchiveType,
  CampaignSaveArchiveUnarchiveReturnType
> = httpPostCancellable('/campaigns/adminarchiveunarchivecampaign');

/** get panel menu info */
export const apiCampaignQuickActionPanelMenu: ApiFunctionType<
  { campaignPermanentUrl: string; InPersonEventOnly: boolean },
  CampaignQuickActionPanelMenuType
> = httpPostCancellable('/campaigns/getQuickActionPanelMenu');

/** campaign actions */
export const apiDeleteCampaign = (id: number): Promise<MyCampaignsListItemType> =>
  httpPost('/campaigns/deletecampaign', {
    id,
  });

export const apiArchiveCampaign = (model: MyCampaignUnArchiveType): Promise<MyCampaignsListItemType> =>
  httpPost('/campaigns/archiveunarchivecampaign', model);

/** end campaign actions */

/** --- contribution emails --- */
export const apiAddContributionNotificationRecipient = ({
  permanentUrl,
  email,
}: // eslint-disable-next-line max-len
DonationPageContributionNotificationEmailsRequestType): Promise<DonationPageContributionNotificationEmailsResponseType> =>
  httpPost('/CampaignsSetup/AddContributionNotificationRecipient', { model: { Email: email }, permanentUrl });

export const apiDeleteContributionNotificationRecipient = ({
  permanentUrl,
  email,
}: // eslint-disable-next-line max-len
DonationPageContributionNotificationEmailsRequestType): Promise<DonationPageContributionNotificationEmailsResponseType> =>
  httpPost('/CampaignsSetup/DeleteContributionNotificationRecipient', { model: { Email: email }, permanentUrl });
/** --- end contribution emails --- */

export const apiLoadUpdatePricingDialog: ApiFunctionType<
  { PermanentUrl: string },
  UpsellLoadUpdatePricingDialogResponseType
> = httpPostCancellable('/CampaignsSetup/LoadUpdatePricingDialog');

export const apiSaveUpdatePricingDialog: ApiFunctionType<{ PermanentUrl: string }, { PermanentUrl: string }> =
  httpPostCancellable('/CampaignsSetup/SaveUpdatePricingDialog');
